import React, { useState } from "react";
import { withBundle, WithBundleProps } from "@amzn/react-arb-tools";
import CloudScapeHeader from "@cloudscape-design/components/header";
import CloudScapeSpaceBetween from "@cloudscape-design/components/space-between";
import CloudScapeButton from "@cloudscape-design/components/button";
import {
  RedButton,
  OrangeButton,
} from "../../components/Buttons/CustomizedButtons";
import { TasksPageForm } from "../../pages/tasksPage/TasksPageForm";
import {
  usePanelContext,
  PanelContextType,
} from "../../context/PanelContextProvider";
import { DeleteModal } from "../../components/Modal/DeleteModal";
import { USER_ACTIONS, PAGE_TITLE } from "../../constants/constants";

const PAGE_TO_FORM: Record<PAGE_TITLE, any> = {
  tasks: TasksPageForm,
  tags: {}, //replace with Page specific form component
  security_teams: {},
};
interface FullPageHeaderProps extends WithBundleProps {
  currentRecords: any; // Will change this during API Implementation
  selectedRecords: number;
  totalRecords: string;
  page: PAGE_TITLE;
}

export const FullPageHeader = withBundle("components.FullPageHeader")(
  (props: FullPageHeaderProps) => {
    const panelContext: PanelContextType | undefined = usePanelContext();
    const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);

    return (
      <React.Fragment>
        {deleteModalOpen && (
          <DeleteModal
            selectedRecords={props.currentRecords} //todo need to implement logic while adding functionality to send recordID's that needs to be deleted to modal component so we can perform delete mutation in that component
            deleteModalOpen={deleteModalOpen}
            setDeleteModalOpen={setDeleteModalOpen}
            page={props.page}
          />
        )}
        <CloudScapeHeader
          variant="awsui-h1-sticky"
          data-testid="full-page-header"
          actions={
            <CloudScapeSpaceBetween size="xs" direction="horizontal">
              {props.selectedRecords > 0 && (
                <RedButton
                  data-testid="header-btn-delete"
                  onClick={() => setDeleteModalOpen(() => true)}
                >
                  {props.bundle.formatMessage(
                    `delete_button_content_for_${props.page}`,
                    {
                      numRecords: props.selectedRecords,
                    }
                  )}
                </RedButton>
              )}
              {props.selectedRecords === 1 && (
                <CloudScapeButton
                  data-testid="header-btn-edit"
                  onClick={() => {
                    const Form = PAGE_TO_FORM[props.page];
                    panelContext!.setSplitPanelContent(
                      <Form
                        taskRecordContent={props.currentRecords[0]}
                        panelContext={panelContext!}
                        panelType={USER_ACTIONS.EDIT}
                      />
                    );
                    panelContext!.setSplitPanelOpen(true);
                  }}
                >
                  {props.bundle.formatMessage("edit_button_content", {
                    page: props.page,
                  })}
                </CloudScapeButton>
              )}
              <OrangeButton
                data-testid="header-btn-create"
                variant="primary"
                onClick={() => {
                  const Form = PAGE_TO_FORM[props.page];
                  panelContext!.setSplitPanelContent(
                    <Form
                      taskRecordContent={{}}
                      panelContext={panelContext!}
                      panelType={USER_ACTIONS.CREATE}
                    />
                  ); // this could be cleaned up
                  panelContext!.setSplitPanelOpen(true);
                }}
              >
                {props.bundle.formatMessage("new_button_content", {
                  page: props.page,
                })}
              </OrangeButton>
            </CloudScapeSpaceBetween>
          }
          counter={props.totalRecords}
        >
          {props.bundle.formatMessage("page_header", {
            page: props.page,
          })}
        </CloudScapeHeader>
      </React.Fragment>
    );
  }
);
